import { timingFunctions } from "polished";
import * as React from "react";
import { Collapse, Form } from "react-bootstrap";
import styled from "styled-components";

import { SvgSprite } from "@skv/core";

import {
  OpportunitySearchQueryState,
  OrganisationSearchQueryState,
} from "@skv/state";

import { Checkbox } from "~/ui";

const FilterHeadingBtn = styled.button.attrs({ type: "button" })`
  color: ${(p) => p.theme.gray900};
  border: 0;
  font-weight: bold;
  padding: 1.3rem 0.8rem 1.3rem 0;
  display: flex;
  align-items: center;
  width: 100%;
  text-align: left;
  background-color: transparent;
  line-height: 1.2;
  overflow: hidden;

  &:hover,
  &:focus {
    background-color: ${(p) => p.theme.gray100};
  }
`;

interface FilterGroup {
  heading: string;
  name: string;
  data: any;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  searchQuery: OpportunitySearchQueryState | OrganisationSearchQueryState;
}

const FilterGroup: React.FC<FilterGroup> = ({
  heading,
  name,
  data,
  onChange,
  searchQuery,
}) => {
  const [open, setOpen] = React.useState(
    searchQuery[name] ? !!searchQuery[name].length : false
  );

  return (
    <fieldset
      css={`
        border-top: 1px solid ${(p) => p.theme.gray300};
      `}
    >
      <legend className="sr-only">{heading}</legend>
      <FilterHeadingBtn
        aria-label={`toggle ${heading}`}
        aria-expanded={open ? "true" : "false"}
        onClick={() => setOpen(!open)}
      >
        {heading}
        <SvgSprite
          id="icons:chev-down"
          width={14}
          height={14}
          css={`
            color: ${(p): string => p.theme.gray700};
            margin-left: auto;
            transition: transform 0.3s ${timingFunctions("easeOutCubic")};
          `}
          style={{
            transform: open ? "rotate3d(1,0,0,180deg)" : "rotate3d(0,0,0,0deg)",
          }}
        />
      </FilterHeadingBtn>
      <Collapse in={open}>
        <div>
          {data.map((filter) => {
            return (
              <Form.Group key={`${name}-${filter.id}`} className="mb-2">
                <Checkbox
                  id={`${name}-${filter.id}`}
                  name={name}
                  type="checkbox"
                  label={filter.name}
                  onChange={onChange}
                  value={filter.id}
                  checked={
                    searchQuery[name]
                      ? searchQuery[name].includes(filter.id)
                      : false
                  }
                />
              </Form.Group>
            );
          })}
        </div>
      </Collapse>
    </fieldset>
  );
};

export default FilterGroup;
